export default {
  REQUEST_REGISTER_WEB3: "REQUEST_REGISTER_WEB3",
  SUCCESS_REQUEST_REGISTER_WEB3: "SUCCESS_REQUEST_REGISTER_WEB3",
  FAILURE_REQUEST_REGISTER_WEB3: "FAILURE_REQUEST_REGISTER_WEB3",

};
